import { Button } from "@/components/ui/button";
import useProfile from "@/hooks/useProfile";
import { CompanyUser } from "@/schema/CompanyUser";
import AddMemberDialog from "@/src/app/(auth)/profile/_components/MemberCard/AddMemberDialog";
import DeleteMemberDialog from "@/src/app/(auth)/profile/_components/MemberCard/DeleteMemberDialog";
import EditMemberDialog from "@/src/app/(auth)/profile/_components/MemberCard/EditMemberDialog";
import MemberTable from "@/src/app/(auth)/profile/_components/MemberCard/MemberTable";
import ResetMemberPasswordDialog from "@/src/app/(auth)/profile/_components/MemberCard/ResetMemberPasswordDialog";
import useMemberDialog from "@/src/app/(auth)/profile/_hooks/useMemberDialog";
import { useTranslation } from "react-i18next";

interface MemberCardProps {
  members: CompanyUser[];
}

function MemberCard({ members }: MemberCardProps) {
  const { t } = useTranslation();
  const { isRoleZero } = useProfile();
  const { setDialog } = useMemberDialog();

  return (
    <div className="my-card">
      <div className="flex justify-between px-6 py-5">
        <div className="text-lg font-medium text-cool-gray-900">
          {t("company-members")}
        </div>
        {isRoleZero && (
          <Button
            onClick={() =>
              setDialog({
                type: "add",
              })
            }
          >
            {t("add-member")}
          </Button>
        )}
      </div>
      <MemberTable members={members} />
      <AddMemberDialog />
      <EditMemberDialog />
      <ResetMemberPasswordDialog />
      <DeleteMemberDialog />
    </div>
  );
}

export default MemberCard;
